import { GoatGetBuyBarData200ResponseInner } from "definitions/goat-api";
import { DetailWithPricesResponseTypeV5 } from "definitions/poizon-api";
import { ProductInfoResponseDto } from "definitions/poizon-api-product";
import { ProductFullResponse } from "definitions/shihuo-api";
import { openDB } from "idb";
import ms from "ms";

export type ProductPriceResponse =
  | ProductInfoResponseDto
  | DetailWithPricesResponseTypeV5
  | ProductFullResponse
  | GoatGetBuyBarData200ResponseInner[];

export type CachedProductPrice = {
  data: ProductPriceResponse;
  cachedAt: number;
};

export const PRICE_CACHE_TTL = ms("12h");

const DB_NAME = "product-price-cache";
const STORE_NAME = "prices";

const dbPromise = openDB(DB_NAME, 1, {
  upgrade(db) {
    db.createObjectStore(STORE_NAME);
  },
});

const isCachedEntry = (value: unknown): value is CachedProductPrice =>
  typeof value === "object" &&
  value !== null &&
  "cachedAt" in value &&
  "data" in value;

export async function getCachedProductPrice(
  key: string,
): Promise<CachedProductPrice | null> {
  const db = await dbPromise;
  const stored = await db.get(STORE_NAME, key);

  if (!isCachedEntry(stored)) return null;

  if (Date.now() - stored.cachedAt > PRICE_CACHE_TTL) return null;

  return stored;
}

export async function setCachedProductPrice(
  key: string,
  value: ProductPriceResponse,
) {
  const db = await dbPromise;
  await db.put(STORE_NAME, { data: value, cachedAt: Date.now() }, key);
}

export async function deleteCachedProductPrice(key: string) {
  const db = await dbPromise;
  await db.delete(STORE_NAME, key);
}
